import * as types from '../type/type'

export const setTheme = (theme) => ({
  type: types.SET_THEME,
  payload: theme,
})
